<template>
  <div class="cell">
    <div class="label">
      <div class="title">
        {{ source.fundsType | status_f(financialType) }}
      </div>
      <div class="time">
        {{
          dayjs(source.receiveTime).format('YYYY-MM-DD HH:mm:ss')
        }}
      </div>
    </div>
    <div
      class="value"
      :class="[source.receiptPayment.indexOf('+') ? 'green' : 'red']"
    >
      {{ source.receiptPayment }}
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    source: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      financialType: (state) => state.options.financialType,
    }),
  },
  filters: {
    status_f(val, list) {
      const i = list.find((item) => item.value === val)
      return (i && i.label) || ''
    },
  },
}
</script>

<style lang="less" scoped>
.cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  .label {
    .title {
      font-size: 28px;
      line-height: 28px;
    }
    .time {
      font-size: 24px;
      color: #808080;
      line-height: 24px;
      padding-top: 16px;
    }
  }
  .value {
    font-size: 40px;
    line-height: 40px;
    &.green {
      color: #8ad300;
    }
    &.red {
      color: #e82035;
    }
  }
}
</style>